module.exports = __webpack_public_path__ + "img/AnnotatedUtilityRolls.33fa5dc3.jpg";